import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';
import { CommonService } from 'src/app/shared/services/angular-service/common.services';

@Component({
  selector: 'app-company-people',
  templateUrl: './company-people.component.html',
  styleUrls: ['./company-people.component.scss'],
})
export class CompanyPeopleComponent implements OnInit {
  @Output() itemAddedToCart: EventEmitter<any> = new EventEmitter();

  @Input() all_data;
  companyData: any;

  public teamMembers;
  public directors;

  isPremium = false;
  plan: any;
  isAdvance = false;
  isFree = false;
  fragment: any;
  productList: any;

  constructor(
    private router: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private companyService: CompanyService,
    private Title: Title,
    private metaTagService: Meta,
    private tansactionService: TansactionService,
    private toastService: ToastService,
    private commonService: CommonService
  ) {}

  linkdin: any;
  designation: any;

  ngOnInit(): void {
    this.router.fragment.subscribe((fragment) => {
      this.fragment = fragment;
    });
    this.companyData = this.all_data;
    if (this.all_data.key_people == undefined) {
      this.all_data.key_people = [];
    }

    this.plan = this.localStorageService.getItem('plan');
    if (this.plan === 'plan_advance') {
      this.isAdvance = true;
    } else if (this.plan === 'plan_premium') {
      this.isPremium = true;
    } else {
      this.isFree = true;
    }

    if(this.all_data.cin == 'L72200DL2000PLC108985' || this.all_data.cin == 'L93030DL2010PLC198141'){
      this.isPremium = true;
      this.isAdvance = false;
      this.isFree = false;
      this.plan = 'plan_premium';
    }

    this.productList = this.all_data.product_list;
    this.commonService.putProductData(this.all_data.product_list['KPD']);

    // this.directors = this.companyData.key_people.filter(data => (data.role.toLowerCase() == 'director' || data.role.toLowerCase() == 'directors' || data.role.toLowerCase() == 'ceo' || data.role.toLowerCase() == 'cto' || data.role.toLowerCase() == 'founder' || data.role.toLowerCase() == 'co-owner'|| data.role.toLowerCase() == 'chairman'|| data.role.toLowerCase() == 'co-founder' || data.role.toLowerCase() == 'managing-director' || data.role.toLowerCase() == 'managing director'));
    // this.teamMembers = this.companyData.key_people.filter(data => (data.role.toLowerCase() !== 'director' || data.role.toLowerCase() !== 'directors' || data.role.toLowerCase() !== 'ceo' || data.role.toLowerCase() !== 'cto' || data.role.toLowerCase() !== 'founder' || data.role.toLowerCase() !== 'co-owner' || data.role.toLowerCase() !== 'chairman'|| data.role.toLowerCase() !== 'co-founder' || data.role.toLowerCase() !== 'managing-director' || data.role.toLowerCase() !== 'managing-director'));

    this.teamMembers = this.companyData.key_people.filter((element) => {
      if (
        element.linkdin !== null &&
        element.linkdin !== undefined &&
        element.linkdin !== ''
      ) {
        if (element.linkdin.includes('https://www.linkedin.com/')) {
          return element;
        }
      }
    });


    this.directors = this.companyData.key_people.filter((element) => {
      if (
        element.linkdin !== null &&
        element.linkdin !== undefined &&
        element.linkdin !== ''
      ) {
        if (!element.linkdin.includes('https://www.linkedin.com/')) {
          delete element.linkdin;
          return element;
        }
      } else if (
        element.linkdin === undefined ||
        element.linkdin === '' ||
        element.linkdin === null
      ) {
        return element;
      }
    });
  }

  clicked = false;

  addToCart(sku) {
    this.clicked = true;
    let currentOption;
    currentOption = {
      sku: sku,
    };
    this.tansactionService.addProductToCart(currentOption).then(
      (data: any) => {
        data['isVisible'] = true;
        // this.itemAddedToCart.emit(data);
        this.toastService.addSingle(
          'success',
          'Email Sent',
          'Please check your email.'
        );
      },
      (err) => {
        this.toastService.addSingle('error', 'Error', err.error.message);
      }
    );
  }
}
